package com.findyourbuddies.website.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontStyle
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.objectFit
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Img

@Composable
fun Header() {
    Box(
        modifier = Modifier
            .fillMaxSize()
            .borderRadius(bottomLeft = 16.px, bottomRight = 16.px)
            .styleModifier {
                backgroundImage("url('/images/background.jpg')")
                backgroundSize("cover")
                backgroundPosition("center")
                backgroundRepeat("no-repeat")
            }
    )

    Box(
        modifier = Modifier
            .fillMaxSize()
            .backgroundColor(rgba(0, 0, 0, 0.4))
            .borderRadius(bottomLeft = 16.px, bottomRight = 16.px),
    )

    Box(
        modifier = Modifier
            .padding(20.px)
            .fillMaxSize(),
        contentAlignment = Alignment.Center
    ) {
        Column(
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Box(
                modifier = Modifier.margin(15.px),
                contentAlignment = Alignment.Center,
            ) {
                Img(
                    src = "/images/logo.svg",
                    alt = "Find Your Buddies Logo",
                    attrs = {
                        style {
                            width(120.px)
                            objectFit(ObjectFit.Fill)
                        }
                    }
                )
            }
            SpanText(
                "find your buddies",
                modifier = Modifier
                    .fontSize(48.px)
                    .color(Colors.White)
                    .margin(16.px)
                    .textAlign(TextAlign.Center)
                    .fontFamily("Waxe", "Arial", "sans-serif")
            )

            SpanText(
                "freediving",
                modifier = Modifier
                    .fontSize(24.px)
                    .color(Colors.White)
                    .margin(bottom = 16.px)
                    .maxWidth(80.percent)
                    .textAlign(TextAlign.Center)
                    .fontFamily("Comfortaa", "Arial", "sans-serif")
            )

            SpanText(
                "Let's hold our breath together",
                modifier = Modifier
                    .fontSize(16.px)
                    .color(Colors.White)
                    .fontStyle(FontStyle.Italic)
                    .textAlign(TextAlign.Center)
                    .fontFamily("Comfortaa", "Arial", "sans-serif")
                    .padding(top = 32.px),
            )

            SpanText(
                "This app is a dream for all freedivers who want to dive with a buddy anywhere in the world, or even just right next to you! Because, as you know, the number one rule of freediving is never dive alone. Each user has their own profile where they can display their level, equipment, and plenty of useful info. Thanks to geolocation, you can easily find freedivers close to you. Finding a buddy? Easier and faster than ever!",
                modifier = Modifier
                    .fontSize(16.px)
                    .color(Colors.White)
                    .lineHeight(1.6)
                    .textAlign(TextAlign.Justify)
                    .maxWidth(800.px)
                    .fontFamily("Comfortaa", "Arial", "sans-serif")
                    .padding(top = 64.px, left = 16.px, right = 16.px),
            )
        }
    }
}
